import { Box, Typography, useTheme } from '@mui/material';

type ToggleButtonProps = {
  options: { key: string; value: string }[];
  selected: string;
  onChange: (option: string) => void;
};

export default function ToggleButtons({ options, selected, onChange }: ToggleButtonProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        backgroundColor: theme.palette.background.focus,
        borderRadius: '12px',
        padding: '4px',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 2,
      }}
    >
      {options.map((option) => {
        const isSelected = selected === option.key;

        return (
          <Typography
            key={option.key}
            onClick={() => onChange(option.key)}
            align="center"
            sx={{
              flex: 1,
              textAlign: 'center',
              backgroundColor: isSelected ? theme.palette.action.hoverSecondary : 'transparent',
              color: isSelected ? theme.palette.text.primary : theme.palette.text.secondary,
              borderRadius: '10px',
              padding: '6px 0',
              marginX: '4px',
              fontWeight: 500,
              fontSize: '0.95rem',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              userSelect: 'none',
              '&:hover': {
                backgroundColor: isSelected ? theme.palette.text.disabled : theme.palette.action.hoverSecondary,
                color: theme.palette.text.primary
              },
            }}
          >
            {option.value}
          </Typography>
        );
      })}
    </Box>
  );
}